import { useSessionContext, useSpinnerContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, DropdownMenu, DropdownItem } from "@common";
import { BurgerIcon } from "@icons";

const NavMenu = () => {

    const { logout } = useSessionContext();
    const navigate = useNavigate();
    const { setSpinnerShow } = useSpinnerContext();

    const logoutClick = async () => {
        setSpinnerShow(true);
        logout();
        try {
            await sunboundPayProxy.logout();
        } catch (error) {
            console.log(error);
        }
        setSpinnerShow(false);
        navigate(`/login`);
    };

    return (
        <DropdownMenu
            trigger={(props) => (
                <Button
                    variant="tertiary"
                    size="md"
                    startIcon={<BurgerIcon />}
                    aria-label="Navigation Menu"
                    className="btn-icon-xl md:btn-text-md"
                    {...props}
                >
                    <span className="hidden md:inline">Menu</span>
                </Button>
            )}
        >
            <DropdownItem onClick={() => navigate(`/`)}>Dashboard</DropdownItem>
            <DropdownItem onClick={() => navigate(`/payment-history`)}>Statements</DropdownItem>
            <DropdownItem onClick={() => navigate(`/myaccount`)}>Settings</DropdownItem>
            <DropdownItem onClick={logoutClick}>Log out</DropdownItem>
        </DropdownMenu>
    );
};

const isNavMenuHidden = (pathname: string): boolean =>
    pathname.startsWith(`/signup/`);

export const useNavMenu = () => {
    const { session } = useSessionContext();
    const { pathname } = useLocation();
    return { showMenu: !!session && !isNavMenuHidden(pathname) };
};

export default NavMenu;
